module.exports = __webpack_public_path__ + "img/86e56b6.gif";